import { useCallback } from "react";
import { useCustomerManagementStore } from "./store";

export const useDataLayer = () => {
  const {
    customerManagement: { user, signupDetails },
  } = useCustomerManagementStore();

  const pushDataLayerEvents = useCallback(
    (eventData = { event: "" }) => {
      if (process.env.REACT_APP_IS_PRODUCTION !== "true") return;
      window.dataLayer = window.dataLayer || [];
      if (!eventData?.user_id && user?.iamId) {
        eventData.user_id = user?.iamId;
      }
      if (!eventData?.email && user?.email) {
        eventData.email = user?.email;
      }
      window.dataLayer.push(eventData);
    },
    [user?.email, user?.iamId]
  );

  const trackDataLayerUser = useCallback(() => {
    if (!user?.iamId) return;
    pushDataLayerEvents({ user_id: user?.iamId });
  }, [pushDataLayerEvents, user?.iamId]);

  const trackDataLayerAuthActions = useCallback(
    (eventName) => {
      let eventData = { event: eventName, email: null };
      eventData.email = user?.email || signupDetails?.email || null;

      if (user?.iamId) {
        eventData.user_id = user?.iamId;
      }
      pushDataLayerEvents(eventData);
    },
    [pushDataLayerEvents, signupDetails?.email, user?.email, user?.iamId]
  );

  return { pushDataLayerEvents, trackDataLayerAuthActions, trackDataLayerUser };
};
